import * as React from "react";
import { forwardRef } from "react";
const SvgUpcomingStep = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 10, cy: 10, r: 9, fill: "#283548", stroke: "#0F172A", strokeWidth: 2 }));
const ForwardRef = forwardRef(SvgUpcomingStep);
export { ForwardRef as ReactComponent };
